import { Label } from '@aws-amplify/ui-react';
import { FC } from 'react';
import TrashIcon from '@/assets/trash.svg';
import { Button } from '@/components/ui/button';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';
import { usePolicies } from '@/hooks/use-policies';
import { api } from '@/redux/api';
import { CreateContactForm } from './create-contact-form';

export const CurrentAddressBooksView: FC = () => {
  const { data: policies } = usePolicies();
  const { organisation } = useCurrentOrganisation();

  const addressBookId = policies?.addressBook.defaultAddressBook.addressBookId;
  const { data: addressBook, isFetching } =
    api.useGetAddressBookWithContactsQuery({
      organisationId: organisation?.id || -1,
      actionType: 'getAddressBookWithContacts',
      addressBookId: addressBookId || '',
    });
  const details = [];
  const [deleteAddressBookContact] = api.useDeleteAddressBookContactMutation();

  if (addressBook && organisation && addressBookId && !isFetching) {
    let primaryContact;
    for (const contact of addressBook.contacts) {
      if (contact.phoneNumber == '22222222') {
        primaryContact = contact;
      } else {
        details.push(
          <Label>
            {contact.name}: {contact.phoneNumber}
          </Label>,
        );
        details.push(
          <Button
            className="place-self-end"
            onClick={() => {
              deleteAddressBookContact({
                organisationId: organisation.id,
                addressBookId: addressBook.addressBookId,
                contactId: contact.contactId ?? '',
                actionType: 'deleteAddressBookContact',
              });
            }}
            variant="primary-warning"
          >
            Delete
            <TrashIcon className="h-6" />
          </Button>,
        );
      }
    }

    return (
      <div className="flex flex-col gap-6">
        <div>
          <SectionHeadingGroup
            className="max-w-96"
            subtitle="Contacts all your users can call"
            title="Default Contacts:"
          />
          <div className="grid-row grid grid-cols-2 items-center gap-2">
            {details}
          </div>
        </div>
        <div>
          <SectionHeadingGroup
            className="max-w-96"
            subtitle="Add a new contact for all your users"
            title="Add contact:"
          />
          <CreateContactForm addressBookId={addressBookId} />
        </div>
        <div className="gap-2">
          <SectionHeadingGroup
            className="max-w-96"
            subtitle="Adjust the name users see when they get a call from the DMP"
            title="Change DMP/ARC caller name:"
          />
          <p className="pt-4 italic">DMP/ARC caller name:</p>
          <p className="font-extrabold">{primaryContact?.name}</p>
          <CreateContactForm
            addressBookId={addressBookId}
            contactFormType={'primaryContact'}
            contactId={primaryContact?.contactId}
          />
        </div>
      </div>
    );
  } else {
    return <p>Loading....</p>;
  }
};
